<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年03月25日 10:30:54 +0800
 * @最后修改时间: 2022-03-01 15:36:36
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Holiday\HolidayType\components\mapToPublicHoliday.vue
 -->
<template>
  <normalDialog
    maxWidth="1000"
    width="70%"
    height="600"
    @close="closePorpertyDialog"
    :title="$t('label_essweb_holidayGroup_form_editHolidayBtnLabel')"
    :dialog="show"
  >
    <template v-slot:content>
      <Tabler
        :headers="headers"
        :defaultSelect="PorpertyData"
        @select="(sel) => (selected = sel)"
        :items="desserts"
        itemKey="uuid"
        :showSelect="showSelect"
      >
        <template v-slot:top>
          <!-- 搜索 -->
          <!-- <v-text-field
            v-model="search"
            class="pr-3"
            background-color="grey lighten-3"
            hide-details
            flat
            single-line
            solo
            prepend-inner-icon="search"
            dense
            :height="45"
            style="max-width:320px;"
            rounded
            label="Search"
          ></v-text-field>-->
        </template>
        <template v-slot:item.name="{ item }">
          {{ $getCommonLangValue(item.holiday_name) }}
        </template>
        <template v-slot:item.date="{ item }">
          {{ $getDateTime(item.holiday_utc_date, "YYYY/MM/DD") }}
        </template>
        <template v-slot:item.utc="{ item }">
          {{ $getUtcByCode(item.holiday_time_zone) }}
        </template>
      </Tabler>
    </template>
    <template v-slot:actions>
      <CardActions saveBtn @save="editPorperty" @cancel="closePorpertyDialog" />
    </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "mapToPublicHoliday",
  props: ["show", "title", "PorpertyData"],
  computed: {
    ...mapGetters(["companyLang"]),
  },
  data() {
    return {
      holidayPorpertyData: null,
      selected: [],
      headers: [
        {
          text: "label_essweb_holiday_form_publicHolidayNameLabel",
          value: "name",
          align: "start",
          sortable: false,
          filter: (value, search, item) => {
            if (!this.search) return true;
            return item.holiday_name.indexOf(this.search) != -1;
          },
        },
        {
          text: "label_essweb_holiday_form_publicHolidayDateLabel",
          value: "date",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_holiday_form_publicHolidayTimeZoneLabel",
          value: "utc",
          align: "start",
          sortable: false,
        },
      ],
      page: 1,
      search: "",
      TableHeight: 470,
      showSelect: true,
      desserts: [],
    };
  },
  watch: {
    PorpertyData(val) {
      // val.map((item) => {
      //   delete item["map_uuid"];
      //   delete item["holiday_abbr"];
      // });
      // console.log(val);
      this.selected = val;
    },
    selected(val) {
      // console.log(val);
    },
  },
  mounted() {
    const that = this;
    that.getHolidayList();
  },
  methods: {
    tableFilter: function (value, search, item) {
      // return (
      //   value != null &&
      //   search != null &&
      //   value.toString().indexOf(this.search) != -1
      // );
    },
    getHolidayList: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_holi_holiday_day",
        url: "/holiday/get-holiday-list/",
      }).then((res) => {
        // 排序
        res.data.sort((objectN, objectM) => {
          var valueN = objectN["holiday_utc_date"];
          var valueM = objectM["holiday_utc_date"];
          if (valueN < valueM) return 1;
          else if (valueN > valueM) return -1;
          else return 0;
        });
        that.desserts = res.data;
      });
    },

    editPorperty: function () {
      this.$emit("editPorperty", this.selected);
    },
    closePorpertyDialog: function () {
      this.$emit("close", false);
    },
    onSearch: function (val) {
      this.search = val;
    },
  },
};
</script>
